export const toFilename = (str) => str.replace(/[\\/:*?"<>|]/g, '_')
